<template>
  <div>
    <div  v-if="!readOnly" class="ml-2 mr-2 mb-2 mt-2">
      <label>{{ $t('operacoes') }} </label>
      <b-form-select
        class="input-pentagro"
        v-model="operationSelected"
        :options="operations"
      ></b-form-select>
    </div>
    <b-form v-if="operationSelected" class="b-layout">
      <div >
        <b-card>
          <div class="inp">
            <label>{{ $t('cap-vol-m-h') }} </label>
            <label>{{ CapacidadeVol.value | ParseNumber}}</label>
          </div>
          <div class="inp">
            <label>{{ $t('ocupacao-1') }} </label>
            <label>{{ Ocupacao.value | ParseNumber}}</label>
          </div>
          <div class="inp" v-if="TBU.value">
            <label>{{ $t('temp-bulbo-umido-c') }} </label>
            <label>{{ TBU.value | ParseNumber }}</label>
          </div>
        </b-card>
      </div>
    </b-form>
  </div>
</template>

<script>
import { SingletonEnginnering } from "../_service/singletonEngineering";
import { ParseToNumber } from "../../utils/tools";
import { FiltersMixin } from "../../../mixins/filtersMixin";


export default {
  props: {
    node: {
      type: Object,
      default: null,
    },
    readOnly: {
      type: Boolean,
      default: false,
    }
  },

   mixins: [FiltersMixin],

  data() {
    return {
      operations: [{ value: null, text:this.$t('selecione-uma-operacao') }],
      operationAttributeList: [],
      operationSelected: null,
      firstLoad: false,
      attrList: ["CapacidadeVol", "Ocupacao", "CalcRefluxo", "TBU"],
      CapacidadeVol: {},
      Ocupacao: {},
      TBU: {},
      equipments: [],
    };
  },

  watch: {
    operationSelected(value) {
      if (this.firstLoad || !value) {
        this.firstLoad = false;
        return;
      }

      this.operationAttributeList = SingletonEnginnering.getOperationsProperties(
        this.operationSelected
      ).filter((operation) => this.attrList.includes(operation.key));

      this.operationAttributeList.forEach( a => {
          if(this.attrList.includes(a.key))
            this[a.key] = a

        if (this[a.key].value)
          this[a.key].value = ParseToNumber(this[a.key].value);
      });
      this.updateNode();
    },

    "CapacidadeVol.value"() {
      this.updateNode();
    },
  },

  methods: {
    loadNode() {
      if (this.node.data[0].index) {
        this.firstLoad = true;
        this.operationSelected = this.node.data[0].index;
      }

      this.node.data.forEach((p) => {
        if (this.attrList.includes(p.caption)) {
          p.value = ParseToNumber(p.value);
          this[p.caption] = p;
        }
      });
    },

    updateNode() {
      let attrs = []
      if(this.TBU.value){
        attrs = [this.Ocupacao.clone(), this.CapacidadeVol.clone(), this.TBU.clone()];
      }else{
        attrs = [this.Ocupacao.clone(), this.CapacidadeVol.clone()];
      }

      this.equipments.forEach((e) => {
        let prop = e.clone();
        prop.value = prop.value ? 1 : 0;
        attrs.push(prop);
      });
      this.node.attrs = attrs;
    },


    loadOperation() {
      let opList = SingletonEnginnering.operations.filter((o) =>
        o.match(/EVC/)
      );
      this.operations.splice(1);
      opList.forEach((op) => this.operations.push({ value: op, text: op }));
    },
  },

  mounted() {
    this.loadOperation();
    this.loadNode();
  },
};
</script>

<style scoped>
form {
  padding: 10px;
  color: #0009;
}

.b-layout {
  width: 100%;
  justify-content: space-between;
}

.inp {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
